import { configureStore } from "@reduxjs/toolkit";
import vars from "utils/vars";
import middleware from "./middleware";
import reducer from "./reducer";

export const store = ({ preloadedState = {}, ...options }) =>
	configureStore({
		...(options || {}),
		preloadedState,
		reducer,
		// Redux Toolkit 2 requires the middleware callback to return the Tuple
		// produced by getDefaultMiddleware() rather than a plain array.
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
		devTools: vars.isDevelopment,
	});

export default store;
